<template>
  <el-drawer
    v-model="drawer"
    direction="rtl"
    :show-close="false"
    size="75%"
    @close="close"
  >
    <template #header>
      <div :class="`header-${titleType} popup-header-box`">
        <div class="popup-title">
          <i @click="back"></i>
          {{ title }}
        </div>
        <slot name="title-right" />
      </div>
    </template>
    <template #default>
      <div v-if="contentType === 1" class="popup-content-data">
        <slot name="content" />
      </div>
      <div v-else-if="contentType === 2" class="popup-content-table">
        <div ref="headerRef" class="popup-header">
          <div class="popup-search">
            <slot name="search" />
          </div>
          <div class="popup-rest">
            <slot name="rest" />
          </div>
        </div>
        <div ref="tableRef" class="popup-article">
          <slot name="table" />
        </div>
      </div>
      <slot v-else name="content" />
    </template>
    <template v-if="isFooter" #footer>
      <template v-if="!customFooter">
        <el-button v-if="showCancelButton" @click="cancel">
          {{ cancelButtonText }}
        </el-button>
        <el-button
          v-if="showConfirmButton"
          type="primary"
          :loading="loading"
          @click="confirm"
        >
          {{ confirmButtonText }}
        </el-button>
      </template>
      <slot v-else name="footer" />
    </template>
  </el-drawer>
</template>
<script lang="ts" setup>
import { ref, watch, onMounted, onUnmounted, nextTick } from "vue";

const drawer = ref(false);

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  // 标题
  title: {
    type: String,
    default: "",
  },
  // 抽屉类型区别标题 1普遍使用于新增及编辑标题类型 2内容包含搜索框标题类型
  titleType: {
    type: Number,
    default: 1,
  },
  // 内容样式 1普遍使用于新增及编辑内容类型 2内容包含搜索框内容类型 3自定义
  contentType: {
    type: Number,
    default: 1,
  },
  // 是否需要底部内容
  isFooter: {
    type: Boolean,
    default: true,
  },
  // 是否自定义底部按钮内容
  customFooter: {
    type: Boolean,
    default: false,
  },
  // 是否显示取消按钮
  showCancelButton: {
    type: Boolean,
    default: true,
  },
  // 是否显示确定按钮
  showConfirmButton: {
    type: Boolean,
    default: true,
  },
  // 取消按钮的文本内容
  cancelButtonText: {
    type: String,
    default: "取消",
  },
  // 确定按钮的文本内容
  confirmButtonText: {
    type: String,
    default: "保存",
  },
});

const emits = defineEmits<{
  (e: "update:visible", flag: boolean): void;
  (e: "close"): void;
  (e: "confirm", callBack: Function): void;
  (e: "cancel"): void;
}>();

const back = () => {
  drawer.value = false;
};

const loading = ref(false);

const confirm = () => {
  loading.value = true;
  emits("confirm", () => {
    back();
    loading.value = false;
  });
};

const cancel = () => {
  back();
  emits("cancel");
};

const close = () => {
  drawer.value = false;
  emits("update:visible", false);
  emits("close");
};

// 动态计算表格高度
const headerRef = ref();
const tableRef = ref();

onMounted(() => {
  // 监听窗口大小变化
  window.addEventListener("resize", handleHeight);
});

onUnmounted(() => {
  window.removeEventListener("resize", handleHeight);
});

const handleHeight = () => {
  nextTick(() => {
    if (!drawer.value) return;
    const headerHeight = headerRef.value.offsetHeight;
    console.log(headerRef.value);

    tableRef.value.style.height = `calc(100% - ${headerHeight}px)`;
  });
};

watch(
  () => props.visible,
  (val) => {
    drawer.value = val;
    val && handleHeight();
  },
  {
    immediate: true,
  }
);
</script>
<style lang="scss" scoped>
.popup-header-box {
  width: 100%;
  height: 60px;
  color: $--color-level-one-important;
  padding: 0 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .popup-title {
    font-size: 16px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: space-between;
    i {
      width: 23px;
      height: 23px;
      margin-right: 8px;
      background-image: url("https://wepaas.oss-cn-shenzhen.aliyuncs.com/upload/images/20240813/PiCLDbF1UpAhUKqK.png");
      display: inline-block;
      cursor: pointer;
    }
  }
}
.header-1 {
  border-bottom: 2px solid $--color-border-normal;
}
.popup-content-data {
  padding: 24px 0;
}
.popup-content-table {
  height: 100%;
  padding-bottom: 20px;
  box-sizing: border-box;
  .popup-header {
    width: 100%;
    padding-bottom: 24px;
    .popup-search {
      padding: 30px 24px;
      border: 2px solid $--color-pagination-normal-bg;
      border-radius: 6px;
    }
  }
}
</style>
